import React from "react";
import hdfc from "../src/assest/hdfc.png";

const PartnerPage = () => {
  const partner = {
    name: "Our Partner Company",
    logo: hdfc,
  };

  return (
    <div className="container py-5 text-center">
      <h2 className="fw-bold mb-2">Our Trusted Partner</h2>
      <p className="text-muted ">
        We proudly collaborate with our valued partner
      </p>

      <img
        src={partner.logo}
        alt={partner.name}
        className="img-fluid"
        style={{ maxHeight: "80px", objectFit: "contain" }}
      />
    </div>
  );
};

export default PartnerPage;
